/**
 * Copy text to clipboard with a fallback for non-secure contexts.
 *
 * Uses navigator.clipboard.writeText when available (HTTPS). Falls back
 * to a textarea + execCommand("copy") for HTTP or when the Clipboard API
 * is not supported. Returns true on success, false on failure.
 */
export async function copyToClipboard(text: string): Promise<boolean> {
  // Preferred: Clipboard API (available in secure contexts — HTTPS)
  if (
    navigator.clipboard &&
    typeof navigator.clipboard.writeText === "function"
  ) {
    try {
      await navigator.clipboard.writeText(text);
      return true;
    } catch {
      // Fall through to fallback (may be blocked by permissions policy)
    }
  }

  // Fallback: textarea + execCommand (works in non-secure contexts)
  try {
    const textarea = document.createElement("textarea");
    textarea.value = text;
    textarea.style.position = "fixed";
    textarea.style.left = "-9999px";
    textarea.style.top = "0";
    textarea.setAttribute("readonly", "");
    document.body.appendChild(textarea);
    textarea.select();
    const ok = document.execCommand("copy");
    document.body.removeChild(textarea);
    return ok;
  } catch {
    return false;
  }
}
